import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-anon-key';

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseKey);

// Database table names
export const TABLES = {
  DOMAINS: 'domains',
  LINKS: 'links',
  ANALYTICS: 'analytics_events',
  USERS: 'users'
};

console.log('🟢 Supabase client initialized');
console.log('📡 URL:', supabaseUrl);
console.log('🔑 Key configured:', supabaseKey ? 'Yes' : 'No');